import { render, staticRenderFns } from "./EditFolderName.vue?vue&type=template&id=66cbcc87&"
import script from "./EditFolderName.vue?vue&type=script&lang=js&"
export * from "./EditFolderName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports